module.exports = __webpack_public_path__ + "img/h-page4-57.485e5460.png";